// extracted by mini-css-extract-plugin
module.exports = {"inner":"Disclosures_inner__Ijti8","text":"Disclosures_text__rybKd","mobile":"Disclosures_mobile__vg4sx","desktop":"Disclosures_desktop__4izoz"};